import {refreshEmailVerified} from "./firebase_services";
import {auth_get_profile} from "../api/auth_api";

// Checks with Firebase whether the email was verified (e.g. in another tab) and reloads the profile if so.
// Returns true when the email is verified.
export const checkEmailVerified = async (updateUser: (data: any) => void) => {
    const verified = await refreshEmailVerified();
    if (verified) {
        const profile = await auth_get_profile();
        updateUser(profile.data);
    }
    return verified;
};
